import { ViewMode } from '@/task-manager/types/view-mode';

export function getTaskLink({
  workstreamId,
  taskId,
}: {
  workstreamId?: string;
  taskId?: string;
}) {
  const searchParams = new URLSearchParams({
    view_mode: ViewMode.PROJECT_MANAGEMENT,
  });

  if (taskId) {
    searchParams.set('id', taskId);
  }

  if (workstreamId) {
    searchParams.set('workstream', workstreamId);
  }

  return {
    pathname: '../tasks',
    search: searchParams.toString(),
  };
}
